import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../reducers/store';
import { actionFetchAdmin } from '../../../actions/admins';
import { EditAdminDetails, EditAdminEmail, EditAdminUsername, Loader, PageHeader, ViewUserAdmin } from '../../../components';
import EditAdminImage from '../../../components/Admins/EditAdminImage/EditAdminImage';

import './editAdmin.css'

const EditAdmin = () => {
  const dispatch                        = useDispatch<AppDispatch>();
  const { id }                          = useParams();
  const {isLoading, singleAdmin }       = useSelector((state: RootState) => state?.adminList);
  const [onePost, setOnePost]           = useState(singleAdmin);
  const lineRef                         = useRef<HTMLDivElement | null>(null);
  const [activeTab, setActiveTab]       = useState<number>(0);
  const tabButtons                      = ['Admin', 'Edit Details', 'Edit EmailAddress', 'Edit Username', 'Edit Image'];
  
  useEffect(() => {
    dispatch(actionFetchAdmin({id}))
  }, [id, dispatch])

  useEffect(() => {
    if (singleAdmin && singleAdmin?._id === id) {
      setOnePost(singleAdmin);
    } else {
      setOnePost(null);
    }
  }, [id, singleAdmin]);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };
  
  useEffect(() => {
    if (lineRef.current) {
      const parent = lineRef.current.parentNode as HTMLElement;
      const activeButton = parent.querySelector('.active') as HTMLElement;

      if (activeButton) {
        lineRef.current.style.width = `${activeButton.offsetWidth}px`;
        lineRef.current.style.left = `${activeButton.offsetLeft}px`;
      }
    }
  }, [activeTab]);

  return (
    <>
      <title>Edit Admin</title>
      <PageHeader title="Edit Admin" description="Welcome to the Admin" download="Download Report" />

      <div className='edit-post-wrapper'>
        {isLoading ? (
            <Loader  />
          ) : onePost ? (
            <>
              <div className='edit-post-body'>
                <div className='edit-post-tab-box'>
                  {tabButtons.map((tab, index) => (
                    <button key={index} className={`edit-post-tab-btn ${activeTab === index ? 'active' : ''}`} onClick={() => handleTabClick(index)} >
                      {tab}
                    </button>
                  ))}
                  <div className='edit-post-btn-line' ref={lineRef}></div>
                </div>

                <div className='edit-post-content-box'>
                  <div className={`edit-post-content ${activeTab === 0 ? 'active' : ''}`}>
                    <ViewUserAdmin details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 1 ? 'active' : ''}`}>
                    <EditAdminDetails id={id} details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 2 ? 'active' : ''}`}>
                    <EditAdminEmail id={id} details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 3 ? 'active' : ''}`}>
                    <EditAdminUsername id={id} details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 4 ? 'active' : ''}`}>
                    <EditAdminImage id={id} details={onePost} />
                  </div>
                </div>
              </div>
            </>
            )
           : (
            <><p>Empty data</p></>
            // <EmptyCard title="profile" linkName="Profile" link="/users/create-profile" />
        )}
      </div>
    </>
  )
}

export default EditAdmin